export default __webpack_public_path__ + "static/adi_head-db6b7733a536fe28d0585d2fad73c016.png";